import { render, staticRenderFns } from "./LocaleMenuItem.vue?vue&type=template&id=d5cffaf8&scoped=true"
import script from "./LocaleMenuItem.vue?vue&type=script&lang=ts"
export * from "./LocaleMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./LocaleMenuItem.vue?vue&type=style&index=0&id=d5cffaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cffaf8",
  null
  
)

export default component.exports